import script from "./BoardSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardSection.vue?vue&type=script&setup=true&lang=js"

import "./BoardSection.vue?vue&type=style&index=0&id=981fae7a&lang=css"

const __exports__ = script;

export default __exports__